// Both transports deliver cumulative JSONL. Publish complete candidates as
// they arrive, without trying to parse the unfinished final line.
export const autocompleteStreamReader = onUpdate => {
  let offset = 0
  const candidates = []
  const ids = new Set()
  let metadata = {}
  return (content, final = false) => {
    const end = final ? content.length : content.lastIndexOf('\n') + 1
    if (end <= offset) return { ...metadata, candidates: [...candidates] }
    const lines = content.slice(offset, end).split(/\r?\n/)
    offset = end
    for (const line of lines) {
      if (!line.trim()) continue
      const record = JSON.parse(line)
      if (record.error) throw new Error(record.error)
      const { candidate, ...details } = record
      metadata = { ...metadata, ...details }
      const id = candidate && (candidate.id || JSON.stringify(candidate))
      if (candidate && !ids.has(id)) {
        ids.add(id)
        candidates.push(candidate)
        onUpdate?.({ ...metadata, candidates: [...candidates] })
      }
    }
    return { ...metadata, candidates: [...candidates] }
  }
}
